/**
 * The News designs' type sizes, as class strings, for what the marketing
 * site's shared sizes (`marketingType`) do not already cover. Each is stated
 * at `md` as well, for the same reason as there: several Type variants set
 * their size at that breakpoint, and an unprefixed class would lose to it.
 */
export const newsType = {
  /**
   * The kind of post above a card's title: 12px bold on an 18px line, its
   * line kept on a post with none so its card is the same height as the rest.
   */
  cardLabel: "min-h-[18px] text-[12px] leading-[18px] md:text-[12px] md:leading-[18px] font-bold text-brand-700",
  /**
   * A card's title: 20px bold on a 25px line, cut at four lines. The design draws it in a near black of its own rather than
   * the site's green-black.
   */
  cardTitle:
    "[font-feature-settings:normal] text-[20px] leading-[25px] md:text-[20px] md:leading-[25px] font-bold md:font-bold tracking-[-0.4px] text-[#181d27] line-clamp-4",
  /**
   * A card's summary: the lines its title leaves of the card's six, two at
   * least and three at most (the card cuts it, NewsCard)
   */
  cardExcerpt: "text-[16px] leading-[24px] md:text-[16px] md:leading-[24px] max-w-none",
  /**
   * The title and summary together: six lines between them, the title one
   * to four and the summary two to three. Always as tall as the
   * tallest way of sharing them, a four-line title over two lines of summary
   * (100px and 48px, 4px apart), so every card is the same height. The
   * summary follows the title directly; anything left over falls under it.
   */
  cardText: "min-h-[152px]",
  /** Previous, Next and the page numbers: 14px medium */
  pager: "text-[14px] leading-[20px] md:text-[14px] md:leading-[20px] font-medium text-brand-700",
  /** A post's date under its title */
  date: "text-[16px] leading-[24px] md:text-[16px] md:leading-[24px] max-w-none",
  /** A pull quote: 36px medium italic on a 45px line from a desktop up */
  quote:
    "[font-feature-settings:normal] text-[24px] leading-[30px] md:text-[24px] md:leading-[30px] lg:text-[36px] lg:leading-[45px] font-medium italic tracking-[-0.48px] lg:tracking-[-0.72px]",
  /** A heading inside a post: 36px medium on a 45px line from a desktop up */
  heading:
    "[font-feature-settings:normal] text-[24px] leading-[30px] md:text-[24px] md:leading-[30px] lg:text-[36px] lg:leading-[45px] font-medium md:font-medium tracking-[-0.48px] lg:tracking-[-0.72px]",
  /** A call-out's heading: 20px bold */
  calloutHeading:
    "[font-feature-settings:normal] text-[20px] leading-[25px] md:text-[20px] md:leading-[25px] font-bold md:font-bold tracking-[-0.4px]",
  /** The credit under a picture: 14px, in the design's grey */
  credit: "text-[14px] leading-[20px] md:text-[14px] md:leading-[20px] text-[#535862] max-w-none",
} as const;
